# Validation status filter: only shows issues with validation_status = "FAILED"
query WfaSessionIssues(
	$runId: ConditionID!
	$offset: Int
	$limit: Int
	$sort: issuesSort
	$textSearch: issuesSearchInsensitive
	$urlFilter: ConditionString
	$severityIdFilter: ConditionString
	$typeIdFilter: ConditionString
	$levelFilter: ConditionString
) {
	issues(
		run_id_eq: $runId
		offset: $offset
		limit: $limit
		sort: $sort
		url_eq: $urlFilter
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
		deleted_eq: { value: false }
		validation_status_eq: { value: "FAILED" }
	) {
		issue_id
		url
		severity_name
		type_name
		elements__component_id
		elements__selector
		page_title
		run_id
		run_time
		session_name
		validation_status
	}

	total: issues(
		run_id_eq: $runId
		url_eq: $urlFilter
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
		deleted_eq: { value: false }
		validation_status_eq: { value: "FAILED" }
	) {
		issue_id_count
	}

	unfiltered_total: issues(run_id_eq: $runId, deleted_eq: { value: false }, validation_status_eq: { value: "FAILED" }) {
		issue_id_count
	}
}
